
export class EntTerritorialsUnits{
  id: number | null = null
  type: string = "";
  code: string = "";
  nameKy: string = "";
  nameRu: string = "";
  polygonJson: string = "";
  children: string[] | null = null
  parent: string = "";
  parentId: number | null = null
  administrativeCenterId: number | null = null
  administrativeCenter: string = "";
}
